import { Helmet } from 'react-helmet-async'

const BASE_URL = 'https://scstrusts.org'
const BRAND = 'SCS Trust Services'

type SEOProps = {
  title: string
  description?: string
  path?: string
  noIndex?: boolean
  jsonLd?: Record<string, unknown> | Record<string, unknown>[]
  image?: string
  type?: 'website' | 'article'
}

export default function SEO({
  title,
  description = 'SCS Trust Services provides professional trust administration tailored to individual needs.',
  path = '',
  noIndex = false,
  jsonLd,
  image,
  type = 'website'
}: SEOProps) {
  const normalizedPath = path ? (path.startsWith('/') ? path : `/${path}`) : ''
  const url = `${BASE_URL}${normalizedPath}`
  const fullTitle = title.includes(BRAND) ? title : `${title} | ${BRAND}`
  const imageUrl = image ? (image.startsWith('http') ? image : `${BASE_URL}${image.startsWith('/') ? image : `/${image}`}`) : `${BASE_URL}/logo.png`

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:alt" content={fullTitle} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  )
}
